export const SCOPE = '.requests';

export const INIT_ALL_REQUESTS = `${SCOPE}:BATCH_REQUEST/INIT_ALL_REQUESTS`;

export const INIT = `${SCOPE}:BATCH_REQUEST/INIT`;

export const SWITCH_REQUEST = `${SCOPE}:BATCH_REQUEST/SWITCH_REQUEST`;

export const SET_PAYLOAD = `${SCOPE}:BATCH_REQUEST/SET_PAYLOAD`;
export const SET_RESPONSE = `${SCOPE}:BATCH_REQUEST/SET_RESPONSE`;

export const FETCHING = `${SCOPE}:BATCH_REQUEST/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}:BATCH_REQUEST/FETCHING_SUCCESS`;
export const FETCHING_FAIL = `${SCOPE}:BATCH_REQUEST/FETCHING_FAIL`;
export const ABORT_FETCHING = `${SCOPE}:BATCH_REQUEST/ABORT_FETCHING`;
